const Brands = {
	UM_ROKU: "Roku",
	UM_SAMSUNG2017: "Samsung (2017)",
    UM_SAMSUNG2021: "Samsung (2021)",
	UM_DISH: "Dish",
	UM_AMAZON: 'Amazon FireTV',
	UM_SONY_TV: 'Sony',
    UM_LG_2019: 'LG (2019)',
    UM_BANGOLUFSEN: "Bangolufsen",
    UM_NV_SHIELD: "NVIDIA SHIELD",
    UM_VIZIO_SMARTCAST: "Vizio SmartCast"
}

export default Brands